import { Container } from 'reactstrap';
import { Outlet } from 'react-router-dom';
import { Navbar, NavbarBrand } from "reactstrap";
import { Link } from 'react-router-dom';

export const TableLayout = () => {
  return (
    <div>
      <header className='sticky-top bg-light'>
        <Navbar className="navbar-expand-sm navbar-toggleable-sm ng-white border-bottom box-shadow mb-3" container light sticky='sticky-top'>
          <NavbarBrand tag={Link} to="/"><img style={{ maxHeight: "50px" }} src="/lc-logo-5-season.png" alt='Logo-LC' /></NavbarBrand>
        </Navbar>
      </header>
      <Container fluid>
        <Outlet />
      </Container>
      <footer className='text-center mt-3'>
          <p>By <a href='https://leningradcenter.ru/'>@Leningrad Center</a> {new Date().getFullYear()} ©</p>
        </footer>
    </div>
  );
}
